import { checkIsInViewPort } from './helpers';

const PLUGIN_SELECTOR = '.standard-paging-container';

// Internal selectors
const LOAD_MORE_WRAPPER_SELECTOR = '.standard-paging__load-more';

/**
 * Represents a simple pager element using a 'load-more' button.
 */
class StandardPager {

  private pagerContainer: HTMLElement = null;

  private loadMoreWrapper: HTMLElement = null;

  private pageCount = 1;
  private pageNumber = 1;

  constructor(element: HTMLElement) {
    this.pagerContainer = element;
  }

  initialize() {
    this.pageCount = parseInt(this.pagerContainer.getAttribute('data-pageCount'));
    let visiblePages = parseInt(this.pagerContainer.getAttribute('data-pagesVisibleFromStart'));
    this.pageNumber = isNaN(visiblePages) ? 1 : visiblePages;
      
    // now show the rest
    if (!isNaN(this.pageCount) && this.pageCount > 0) {
      this.initializeLoadMore(visiblePages);
      this.setStyles();
    }
  }

  private initializeLoadMore(visiblePages: number) {
    // Add listeners
    this.loadMoreWrapper = this.pagerContainer.querySelector(LOAD_MORE_WRAPPER_SELECTOR);
    if (!this.loadMoreWrapper) {
      return;
    }

    const loadMoreButton = this.loadMoreWrapper.querySelector('.btn');
    if (!loadMoreButton) {
      return;
    }

    loadMoreButton.addEventListener('click', (evt) => {
      evt.preventDefault();

      // initial value higher than 1 page, show remaining items on current page
      if(!isNaN(visiblePages)) {
        this.showPage(this.pageNumber, this.pageCount);
      }

      if (this.pageNumber < this.pageCount) {
        this.pageNumber++;
        this.showPage(this.pageNumber, this.pageCount);
      }

      return false;
    });
  }

  private showPage(pageNumber: number, pageCount: number) {
    const pages = this.pagerContainer.querySelectorAll(`.standard-paging__items-page[data-page="${pageNumber}"]`);
    if (!pages.length) {
      return;
    }

    pages.forEach(page => {
      const styledElements = page.querySelectorAll<HTMLElement>('[data-style]');
      styledElements.forEach(elem => {
        this.setStyle(elem);
      });

      page.classList.remove('hidden');
    });

    if (pageNumber >= pageCount && this.loadMoreWrapper) {
      this.loadMoreWrapper.classList.toggle('hidden', true);
    }
  }

  private setStyles() {
    // we could improve this hacky-way of determining if element is in view... maybe refactor to PageSlider
    setInterval(() => {
      const dataStyleElements = document.querySelectorAll<HTMLElement>('[data-style]');
      dataStyleElements.forEach(dataStyleElement => {
        if (checkIsInViewPort(this.pagerContainer, dataStyleElement, true)) {
          this.setStyle(dataStyleElement);
        }
      });
    }, 10);
  }

  private setStyle(element: HTMLElement) {
    element.setAttribute('style', element.getAttribute('data-style'));
  }

}

function initializeOverviewPaging() {
  const elements = document.querySelectorAll<HTMLElement>(PLUGIN_SELECTOR);
  elements.forEach(element => {
    const plugin = new StandardPager(element);
    plugin.initialize();
  });
}

export { initializeOverviewPaging };
